import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { ANALYSIS_TYPE_FALLBACK_VARIANT, ANALYSIS_TYPE_META } from '@/constants/analysisTypes';
import { cn } from '@/lib/utils';

interface AnalysisTypeBadgeProps {
  type: string;
  className?: string;
}

/**
 * `type` is a free-form backend string, so an unrecognised one shows verbatim
 * rather than a generic "other": the raw value is the only clue a reader gets
 * about what actually ran.
 */
const AnalysisTypeBadge: React.FC<AnalysisTypeBadgeProps> = ({ type, className }) => {
  const { t } = useTranslation();
  const meta = ANALYSIS_TYPE_META[type];

  return (
    <Badge
      variant={meta ? meta.variant : ANALYSIS_TYPE_FALLBACK_VARIANT}
      className={cn('revy-cjk px-2 py-0 text-[11px] font-medium leading-[1.5]', className)}
    >
      {meta ? t(meta.labelKey) : type}
    </Badge>
  );
};

export default AnalysisTypeBadge;
